module.exports = __webpack_public_path__ + "ed180ea27827b0f1af34db6f9e554e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon_specific_2x.png
// module id = 123
// module chunks = 0 1 2 3 4